// removed by extract-text-webpack-plugin
module.exports = {"PreviewWrapper":"_1iDP9JjS279ikWbjF7oqvu","ActiveButtonWrapper":"UOPpou4jRWaw-LoYLdSBB","ActiveButton":"_1HQU6pRNpYidcX_B-rlqC","PreviewStatus":"RMu5KLsJ7kwXVi6Kd3Y5X","IsTypingWrapper":"_1ykQiuehMlgWEBqjKnr-rH","ArrowWrapper":"_18WFBIMMqBtfXwR0wMvqbc","PreviewImage":"_1JRzYMQeau-oPv0X0-0ARI","PreviewTitle":"_1ge48UolPlehvs-hKWjTm6","previewBodyInner":"_3ygxpJpTXIQOvpuYtAGK9K","DateCreated":"_20H-Llmr5PtU_9rX-lRFNX"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Conversation/Preview/style.css
// module id = 701
// module chunks = 0